export default {
  GET_LOCATION: 'GET_LOCATION',
  GET_LOCATION_FAILED: 'GET_LOCATION_FAILED',
  FILTER_CENTERS: 'FILTER_CENTERS',
  FILTER_CENTERS_FAILED: 'FILTER_CENTERS_FAILED',
  LOADING: 'LOADING',
  LOADING_FILTER: 'LOADING_FILTER',
};
